import React from 'react';
import {
  Card,
  Checkbox,
  List,
  ListItem,
  ListItemIcon,
  ListItemText
} from '@material-ui/core';
import CardTitle from '../../../common/card/CardTitle';
import GroupIcon from '@material-ui/icons/Group';
import { useFindGroups } from '../../groups/Group.hooks';
import { useFindUser, usePatchUser } from '../../../user/User.hooks';
import { Group } from '../../groups/Group.interface';

export interface UserGroupCardProps {
  userId: number;
}

const UserGroupCard: React.FC<UserGroupCardProps> = ({ userId }) => {
  const { groupList } = useFindGroups(true);
  const { user: patchedUser, patch } = usePatchUser(userId);
  const { user: origUser } = useFindUser(userId, true);
  const user = patchedUser ? patchedUser : origUser; // initial user versus getting user from patch() response
  return (
    <Card>
      <CardTitle>
        <GroupIcon />
        Team Assignments
      </CardTitle>
      <List>
        {groupList &&
          groupList.data.map(group => (
            <ListItem
              key={group.id}
              role={undefined}
              dense
              button
              onClick={() => { }}
            >
              <ListItemIcon>
                <Checkbox
                  edge='start'
                  disableRipple
                  color='primary'
                  checked={
                    user?.groups?.find(g => g.id === group.id) ? true : false
                  }
                  onChange={event => {
                    if (event.target.checked) {
                      user?.groups?.push(group);
                    } else {
                      const filtered =
                        user &&
                        user.groups &&
                        user.groups.filter(g => {
                          return g.id !== group.id;
                        });

                      if (user && user.groups && filtered) {
                        user.groups = filtered as Group[];
                      }
                    }
                    if (user && user.groups) {
                      patch({ groups: user.groups });
                    }
                  }}
                />
              </ListItemIcon>
              <ListItemText primary={group.name} />
            </ListItem>
          ))}
      </List>
    </Card>
  );
};

export default UserGroupCard;
